const notificationsType = [
  {
    label: "Quotes",
    value: "quotes",
  },
  {
    label: "Services",
    value: "services",
  },
  {
    label: "System",
    value: "system",
  },
  {
    label: "User",
    value: "user",
  },
  {
    label: "Buildings",
    value: "buildings",
  },
  {
    label: "Prices",
    value: "prices",
  },
  {
    label: "Documents",
    value: "documents",
  },
];

export default notificationsType;
